<template>
  <div class="header-blank">
    <!--    头部的logo-->
<!--     <img class="logo" src="../img/pageLogo.png" />-->
<!--     <img class="logo" src="../img/move.png" />-->
     <img class="logo" src="../img/whalogo.png" />

    <!--    中间的菜单-->
    <div class="nav">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
      >
        <el-menu-item index="1" v-show="menusList.indexOf('HOME_PAGE')!='-1'">首页</el-menu-item>
        <el-menu-item index="2" v-show="menusList.indexOf('MONITOR_CENTER')!='-1'">监测中心</el-menu-item>
        <el-menu-item index="3" v-show="menusList.indexOf('ALARM_CENTER')!='-1'">异常中心</el-menu-item>
        <el-menu-item index="4" v-show="menusList.indexOf('DEVICE_CENTER')!='-1'">设备中心</el-menu-item>
        <el-menu-item index="5" v-show="menusList.indexOf('CONFIG_CENTER')!='-1'">配置管理</el-menu-item>
<!--        <el-menu-item index="6" v-show="menusList.indexOf('CONFIG_CENTER')!='-1'">打标管理</el-menu-item>-->
      </el-menu>
    </div>

    <!--    右侧个人信息-->
    <div
      class="userMessage"
      @mouseenter="hoverState = true"
      @mouseleave="hoverState = false"
    >
      <div class="userMessage__name">
        <div>
          <span>{{ userName }}</span>
          <img v-show="!hoverState" src="../img/downShape.png" />
          <img v-show="hoverState" src="../img/upShape.png" />
        </div>
      </div>

      <div class="userMessage__menu" v-show="hoverState">
        <div class="userMessage__menu__up" @click="showPersonCenter()">
          <img src="../img/user.png" />个人中心
        </div>
        <div @click="exitLogin()"><img src="../img/btn.png" />退出登录</div>
      </div>
    </div>
    <audio controls ref="audio" class="aud" style="display: none" >

      <source src="../../../assets/bj.mp3" />

    </audio>
  </div>

</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
export default {
  name: "HomePage",
  data() {
    return {
      activeIndex: "1",
      hoverState: false,
      userName: "",
      menusList:"",
      roleType:"",
    };
  },
  methods: {
    bofang1(){
      let music1 = new Audio(); //建立一个music1对象

      music1 = require("../../../assets/bj.mp3");//通过require引入音频

      this.$refs.audio.src = music1;//此处的audio为代码ref="audio"中的audio

      this.$refs.audio.play();//play()为播放函数

    },
    choseindex(){
      if(this.menusList.indexOf('HOME_PAGE')!='-1'){
        this.activeIndex='1'
      }else if(this.menusList.indexOf('MONITOR_CENTER')!='-1') {
        this.activeIndex='2'
      }else if(this.menusList.indexOf('ALARM_CENTER')!='-1') {
        this.activeIndex='3'
      }else if(this.menusList.indexOf('DEVICE_CENTER')!='-1') {
        this.activeIndex='4'
      }else if(this.menusList.indexOf('CONFIG_CENTER')!='-1') {
        this.activeIndex='5'
      }
    },
    showPersonCenter() {
      this.$router.push("/personalCenter");
    },

    handleSelect(key, keyPath) {
      sessionStorage.setItem("active", key);
      let url = "";
      if (sessionStorage.getItem("url") == 2)
      {
        switch (key) {
          case "1":
            url = "/singlehome";
            //
            // url = "/newhome";
            break;
          case "2":
            url = "/stationList";
            break;
          case "3":
            url = "/electricWarn";
            break;
          case "4":
            url = "/deviceManger";
            break;
          case "5":
            url = "/userManage";
            break;
          case "6":
            url = "/godManger";
        }
      } else {
        switch (key) {
          case "1":
            // url = "/areaUer";
            url = "/newhome";
            break;
          case "2":
            url = "/stationList";
            break;
          case "3":
            url = "/electricWarn";
            break;
          case "4":
            url = "/deviceManger";
            break;
          case "5":
            url = "/userManage";
            break;
          case "6":
            url = "/godManger";
        }
      }
      this.$router.push(url);
    },
    exitLogin() {
      this.$router.push("/newlogin");
    },
  },
  created() {},
  mounted() {
    let that=this

    Vue.prototype.menusList=JSON.parse(localStorage.getItem("menusList"))
    this.menusList=Vue.prototype.menusList

    this.userName = localStorage.getItem("userName");
    Bus.$on("changeheader", (val) => {

      that.activeIndex=val
    });
    Bus.$on("openmui", (val) => {

      that.bofang1()
    });
    this.activeIndex = sessionStorage.getItem("active")
      ? sessionStorage.getItem("active")
      : "1";
    this.roleType=sessionStorage.getItem("url");
    // this.choseindex()
  },
  watch: {},
  components: {},
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.header-blank {
  width: 100%;
  height: 56px;
  background-image: url("../img/headerPage.png");
  display: flex;
  align-items: center;
  //background-repeat: no-repeat;
  position: relative;
  .logo {
    margin-left: 24px;
    width: 116px;
    height: 35px;
  }
  .nav {
    margin-left: 8vw;
    .el-menu-demo {
      background: none;
      .el-menu-item {
        font-size: 16px !important;
        color: #ffffff;
        margin-left: 30px;
      }
      .el-menu-item.is-active {
        color: #ffff;
      }
      .el-menu-item:hover {
        color: rgba(255, 255, 255, 0.8);
        background: none;
      }
      .el-menu-item:active {
        color: #fff;
        background: none;
      }
      .el-menu-item:focus {
        color: #fff;
        background: none;
      }
    }
  }
  .userMessage {
    position: absolute;
    right: 6%;
    font-weight: normal;
    color: #ffffff;
    font-size: 16px;
    width: 136px;
    text-align: center;
    &__name {
      width: 136px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      position: relative;
      padding-bottom: 5px;
      div {
        width: 106px;
        img {
          position: absolute;
          top: 50%;
          margin-left: 8px;
          transform: translateY(-50%);
        }
      }
    }
    &__menu {
      width: 136px;
      height: 100px;
      border-radius: 4px;
      box-shadow: 0px 2px 4px 2px rgba(115, 115, 115, 0.2);
      color: #252b3c;
      font-size: 14px;
      background: #ffffff;
      cursor: pointer;
      position: absolute;
      z-index: 2000;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      &__up {
        border-bottom: 1px solid #e4e7ed;
      }
      div {
        width: 136px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        position: relative;
        img {
          position: absolute;
          top: 50%;
          left: 18px;

          transform: translateY(-50%);
        }
      }
      div:hover {
        background-color: #edf0f3;
      }
    }
    .userMessage__menu:hover {
      border-radius: 4px;
    }
  }
}
</style>
